import { createBrowserHistory } from "history";

// This app's browser history is exposed as a singleton to support use in two places:
//
//   * The app's `Router` instance.
//   * In `redux-query-sync` in the store.
//
export const history = createBrowserHistory();
